var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLogoEmail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "url(#paint0_linear_5969_272280)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7216 34V16.5455H24.4034C25.6648 16.5455 26.7131 16.7443 27.5483 17.142C28.3892 17.5341 29.017 18.071 29.4318 18.7528C29.8523 19.4347 30.0625 20.2074 30.0625 21.071C30.0625 21.7812 29.9261 22.3892 29.6534 22.8949C29.3807 23.3949 29.0142 23.8011 28.554 24.1136C28.0938 24.4261 27.5795 24.6506 27.0114 24.7869V24.9574C27.6307 24.9915 28.2244 25.1818 28.7926 25.5284C29.3665 25.8693 29.8352 26.3523 30.1989 26.9773C30.5625 27.6023 30.7443 28.358 30.7443 29.2443C30.7443 30.1477 30.5256 30.9602 30.0881 31.6818C29.6506 32.3977 28.9915 32.9631 28.1108 33.3778C27.2301 33.7926 26.1222 34 24.7869 34H17.7216ZM20.8835 31.358H24.2841C25.4318 31.358 26.2585 31.1392 26.7642 30.7017C27.2756 30.2585 27.5312 29.6903 27.5312 28.9972C27.5312 28.4801 27.4034 28.0142 27.1477 27.5994C26.892 27.179 26.5284 26.8494 26.0568 26.6108C25.5852 26.3665 25.0227 26.2443 24.3693 26.2443H20.8835V31.358ZM20.8835 23.9688H24.0114C24.5568 23.9688 25.0483 23.8693 25.4858 23.6705C25.9233 23.4659 26.267 23.179 26.517 22.8097C26.7727 22.4347 26.9006 21.9915 26.9006 21.4801C26.9006 20.804 26.6619 20.2472 26.1847 19.8097C25.7131 19.3722 25.0114 19.1534 24.0795 19.1534H20.8835V23.9688Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5969_272280",
    x1: 24.9993,
    y1: 0,
    x2: 24.9993,
    y2: 49.9986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E11D34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A32036"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLogoEmail);
export default __webpack_public_path__ + "static/media/ic_logoEmail.253d5614332b499eebb9a9eb9300b254.svg";
export { ForwardRef as ReactComponent };